let Events = {

  /**     * Zoom In     */
  PANORAMA_ZOOM_IN: 'PanoramaZoomIn',

  /**     * Zoom Out     */
  PANORAMA_ZOOM_OUT: 'PanoramaZoomOut',

  /**     * 场景选择     */
  SCENE_SEL: 'SceneSelect',

  /**     * 场景切换     */
  SCENE_SWITCH: 'SceneSwitch',

  /**     * 弹窗关闭     */
  POPUP_CLOSE: 'PopupClose',

  /**     * 场景切换结束     */
  SCENE_SWITCH_END: 'SceneSwitchEnd',

  /**     * 场景默认视角     */
  SCENE_DEFAULT_LOOK: 'SceneDefaultLook',

  /**     * 小行星入场效果     */
  LITTLE_IN_SCENE_ANI: 'LittleInSceneAni',

  /**     * 小行星入场效果结束     */
  LITTLE_IN_SCENE_END: 'LittleInSceneEnd',

  /**     * 按钮事件     */
  MENU_EVENTS: 'MenuEvents',

  /**     * 建筑外观事件     */
  MENU_BUILDING_CLICK: 'MenuBuildingClick',

  /**     * 鸟瞰事件     */
  MENU_ABOVE_VIEW: 'MenuAboveView',

  /**     * 场景介绍显示隐藏     */
  MENU_SCENE_DETAILS: 'MenuSceneDetails',

  /**     * 讲解人员显示隐藏     */
  MENU_EXPLAIN_STATUS: 'MenuExplainStatus',

  /**     * 返回事件     */
  MENU_RETURN_SCENE: 'MenuReturnView',

  /**     * 操作演示     */
  MENU_OPERATE_EXPLAIN: 'MenuOperateExplain',

  /**     * 设备展示     */
  MENU_DEVICES_SHOW: 'MenuDevicesShow',

  /**     * 项目介绍视频     */
  MENU_VIDEO_SHOW: 'MenuVideoShow',

  /**     * 项目介绍弹窗     */
  MENU_PROJECT_DETAILS: 'MenuProjectDetails',

  /**     * 项目介绍弹窗     */
  MENU_3D_DETAILS: 'Menu3DDetails',

  /**     * 场景缩略图     */
  MENU_THUMBS_SHOW: 'MenuThumbsShow',

  /**     * 设备展示     */
  MENU_HOME: 'MenuHome',

  /**     * 地图全屏     */
  MAP_MAX: 'MapMax',

  /**   * 视频讲解显示   */
  EXPLAIN_VIDEO_SHOW: 'ExplainVideoShow',

  /**   * 视频讲解隐藏   */
  EXPLAIN_VIDEO_HIDE: 'ExplainVideoHide',

  /**
   * 播放ppt
   */
  PPT_SHOW: 'PPTShow',

  /**
   * 播放ppt
   */
  VIDEO_SHOW: 'VideoShow',

  /**     * 方案     */
  MENU_SCHEME: 'MenuScheme',

  /**     * 视角刷新     */
  SCENE_VIEW_ANGLE_UPDATE: 'SceneViewAngleUpdate'

}
export {Events}



// WEBPACK FOOTER //
// ./src/com/Events.js